import {
	appVersionRaw,
	sentryReleaseAnalytics,
} from '@jepto/environments/app-version.generated';

export const environment = {
	production: true,
	staging: false,
	develop: false,
	hostName: 'https://app.jepto.com',
	appSyncConfig: {
		graphqlEndpoint:
			'https://s4ndyt2jozgg3fwbs2goil4u2u.appsync-api.ap-southeast-2.amazonaws.com/graphql',
		customEndpoint: 'https://api.jepto.com/graphql',
		eventsEndpoint: 'https://event.jepto.com/event',
		region: 'ap-southeast-2',
		authenticationType: 'iam',
	},
	cognitoSettings: {
		identityPoolId: 'ap-southeast-2:5ba2aad7-d378-4283-ab73-4845f3cc7acf',
		UserPoolId: 'ap-southeast-2_lICqveE7J',
		ClientId: '22htg2iulaoos6e3h3l27vnb03',
	},
	sentry: {
		enabled: true,
		dsn: 'https://38a20e46129d18839d8b43c884faf76a@o4510870850437120.ingest.us.sentry.io/4510870852403200',
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
		debug: false,
	},
	appVersion: `v${appVersionRaw}`,
	appVersionRaw,
	sentryRelease: sentryReleaseAnalytics,
	reportViewUrl: 'https://api.app.jepto.com/report/view',
	/** Flip to true after stg verification of /report/view IAM auth and load. */
	reportViewTrackingEnabled: false,
};
